<template>
  <div class="pwc-question-form">
    <header class="pwc-question-header">
      <img src="../../assets/logo.png">
    </header>
    <div class="pwc-question-container">
      <aside class="pwc-question-aside">
        <ul class="pwc-question-list">
          <li v-for="(p, index) in QuestionFromObjMap.Pages" :key="index">
            <v-icon class="icon-action" :class="{'checked': lineChecked(index), 'circle-checked': isChecked(index)}">{{ showIcon(index) }}</v-icon>
            <span :class="{'question-title': currentPage === index, 'circle-checked': isChecked(index)}" @click="changeCurrentQuestion(index)">{{ p.Title }}</span>
          </li>
        </ul>
      </aside>
      <main class="pwc-question-main">
        <h3>{{ QuestionFromObjMap.Pages[currentPage].Title }}</h3>
        <v-form ref="form" class="pwc-form-data">
          <v-container grid-list-md text-xs-center>
            <v-layout v-if="!showPlus" row wrap>
              <v-flex v-for="(item, i) in currentPageQuestions" :key="i" :xs12="!item.half" :xs6="item.half">
                <p-common v-model="answers[item.name]" :meta="item" :rule-fuc="ruleFuc" :field-type="FormPropertyTypes" :all-show-other="allShowOther" />
              </v-flex>
            </v-layout>
            <div v-else>
              <v-layout v-for="(subP, index) in currentPageQuestions" :key="index" row wrap :class="{'added-questions': index !== 0}">
                <v-flex xs2 offset-xs10>
                  <v-btn v-if="index !== 0" style="width: 30px" color="#d04a02" depressed outline block @click="handleRevoke(index)">
                    <v-icon class="icon-action">fas fa-trash</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex v-for="(item, i) in subP" :key="i" :xs12="!item.half" :xs6="item.half">
                  <p-common v-model="answers[item.name]" :meta="item" :rule-fuc="ruleFuc" :field-type="FormPropertyTypes" :all-show-other="allShowOther" />
                </v-flex>
              </v-layout>
            </div>
            <v-layout v-if="showPlus" row class="pwc-form-action" justify-space-around>
              <v-flex xs2>
                <v-btn :disabled="subPages[currentPage] === currentPageObj.Questions.length - 1" color="#d04a02" depressed outline block @click="handlePlus">
                  <v-icon class="icon-action">fas fa-plus</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row class="pwc-form-action" justify-space-around>
              <v-flex xs5>
                <v-btn color="#d04a02" depressed outline block @click="handleback">上一步</v-btn>
              </v-flex>
              <v-flex xs5>
                <v-btn color="#d04a02" depressed outline block @click="handleNext">下一步</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </main>
    </div>
  </div>
</template>
<script>
import {
  FormPropertyTypes,
  QuestionFromObjMap
} from './forminfo/YPApplicationForm'
import PCommon from './components/common'
const currentPage = 0

const patternRules = {
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^1\d{10}$/
}

export default {
  components: {
    PCommon
  },
  data() {
    return {
      QuestionFromObjMap,
      FormPropertyTypes,
      currentPage,
      subPages: {},
      currentPageQuestions: [],
      answers: {},
      allShowOther: {},
      hasChecked: {}
    }
  },
  computed: {
    currentPageObj() {
      return this.QuestionFromObjMap.Pages[this.currentPage]
    },
    showPlus() {
      return this.currentPageObj.Multiple
    }
  },
  mounted() {
    this.initData()
    this.getFullQuestionList()
  },
  methods: {
    // 初始化数据
    initData() {
      if (this.showPlus) {
        this.subPages[this.currentPage] = 0
        this.currentPageQuestions = this.currentPageObj.Questions[
          this.subPages[this.currentPage]
        ]
      } else {
        this.currentPageQuestions = this.currentPageObj.Questions
      }
    },
    showIcon(index) {
      if (this.currentPage === index) {
        return 'fas fa-circle'
      } else if (this.hasChecked[index]) {
        return 'far fa-check-circle'
      } else {
        return 'far fa-circle'
      }
    },
    isChecked(index) {
      return this.currentPage === index || this.hasChecked[index]
    },
    lineChecked(index) {
      return this.currentPage > index || (this.hasChecked[index] && index < Object.keys(this.hasChecked).pop())
    },
    // 问题验证
    ruleFuc(p) {
      const types = [FormPropertyTypes.Textarea, FormPropertyTypes.Textfield]
      const tipContent = types.includes(p.type) ? '请输入' : '请选择'
      let rules = []
      if (p.required) {
        rules = rules.concat([v => !!v || tipContent])
      }
      if (patternRules[p.dataType]) {
        rules = rules.concat([v => patternRules[p.dataType].test(v) || tipContent + '正确的' + p.label])
      }
      return rules
    },
    changeCurrentQuestion(index) {
      if (this.isChecked(index)) {
        this.currentPage = index
        this.currentPageQuestions = this.currentPageObj.Questions
      }
    },
    // 上一步
    handleback() {
      if (this.currentPage === 0) {
        return
      }
      this.$refs.form.resetValidation()
      this.currentPage--
      if (this.showPlus) {
        this.currentPageQuestions = []
        for (let i = 0; i <= this.subPages[this.currentPage]; i++) {
          this.currentPageQuestions.push(this.currentPageObj.Questions[i])
        }
      } else {
        this.currentPageQuestions = this.currentPageObj.Questions
      }
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    // 下一步
    handleNext() {
      // const validate = this.$refs.form.validate()
      if (this.currentPage < this.QuestionFromObjMap.Pages.length - 1) {
        this.hasChecked[this.currentPage] = true
        this.currentPage++
        if (this.showPlus) {
          this.currentPageQuestions = []
          for (let i = 0; i <= this.subPages[this.currentPage]; i++) {
            this.currentPageQuestions.push(this.currentPageObj.Questions[i])
          }
        } else {
          this.currentPageQuestions = this.currentPageObj.Questions
        }
      }
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    // 加一组
    handlePlus() {
      if (this.showPlus && this.currentPageObj.Questions[this.subPages[this.currentPage] + 1]) {
        this.subPages[this.currentPage]++
        this.currentPageQuestions.push(this.currentPageObj.Questions[this.subPages[this.currentPage]])
      }
    },
    // 减去一组
    handleRevoke(index) {
      if (this.subPages[this.currentPage] === 0) {
        return
      }
      if (this.showPlus && this.currentPageQuestions.length > 1) {
        // 当前的题目数
        const tempRemove = this.currentPageQuestions[index]
        console.log('tempRemove', tempRemove)
        for (let i = 0; i < tempRemove.length; i++) {
          delete this.answers[tempRemove[i].name]
          delete this.allShowOther[tempRemove[i].id]
        }
        this.currentPageQuestions.splice(index, 1)
        // 减去一项
        this.subPages[this.currentPage]--
      }
    },
    // 列出所有的问题
    getFullQuestionList() {
      const full = []
      this.QuestionFromObjMap.Pages.forEach((p, index) => {
        this.subPages[index] = 0
        const tempQ = p.Questions || []
        if (tempQ.length > 0 && p.Multiple) {
          tempQ.forEach(tQ => {
            full.push(...tQ)
          })
        } else {
          full.push(...tempQ)
        }
      })
      return full
    }
  }
}
</script>
<style lang="scss">
.pwc-question-form {
  font-family: 'Microsoft YaHei', Georgia, "Times New Roman", Times, serif;
  background-image: url("../../assets/register-form-bg.jpg");
  height: 100vh;
  overflow: hidden;
  .pwc-question-header {
    margin: auto;
    box-sizing: border-box;
    height: auto;
    width: auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    width: 100%;
    padding: 20px 0;
    border-bottom: 1px solid #eee;
    img {
      width: 400px;
    }
  }
  .pwc-question-container {
    margin: 0 auto;
    max-width: 1200px;
    display: flex;
    .pwc-question-aside {
      width: 316px;
      min-height: calc(100vh - 116.75px);
      background-color: #fff;
      border-right: 1px solid #eee;
      .pwc-question-list {
        margin-top: 50px;
        list-style: none;
        line-height: 40px;
        .icon-action {
          font-size: 16px;
          margin-right: 3px;
          margin-right: 2px;
        }
        .circle-checked {
          color:red;
          cursor: pointer;
        }
        li:not(:last-child) {
          .icon-action {
            &::after {
              content: "";
              border-left: 1px solid #aaa;
              height: 20px;
              position: relative;
              left: -9px;
              top: 20px;
            }
          }
        }
        li:not(:last-child) {
          .checked {
            &::after {
              border-left: 1px solid red;
            }
          }
        }
        .question-title{
          background-color: rgba(255,0,0,0.1);
          line-height: 25px;
          display: inline-block;
          padding: 2px 6px;
        }
      }
    }
    .pwc-question-main {
      width: 100%;
      height: calc(100vh - 118px);
      background-color: #fff;
      padding: 25px;
      overflow: auto;
      .added-questions {
        padding: 10px;
        border: 2px dashed #ccc;
        margin-bottom: 10px;
        border-radius: 10px;
      }
    }
  }
}
</style>
